import * as _ from "lodash";
import { LIB_PREFIX, IManifest, ContentTypes } from "../../TypesAndIdentifiers";
import ItemPath from "./ItemPaths";
import BaseConfig from "../utils/BaseConfig";
import { Observable } from "rxjs";

export default class ItemConfig extends BaseConfig {
  public readonly paths = new ItemPath(this.itemProps.type);
  public contentType = ContentTypes.ITEM;
  public muteState: string;
  public contentTypeID;
  public activityObservable: Observable<any> | null;

  constructor(public readonly itemProps: any) {
    super();
    this.contentTypeID = itemProps.type;
  }
}
